import { Link } from "react-router-dom";

/* Krans — ultra-premium black-card. Centurion/Diamond-tier point hoarder. */
const P = {
  bg: "#08080A", panel: "#101012", ink: "#F2EDE2", inkDim: "#7B7568",
  brass: "#B89968", brassLite: "#D4B380", border: "#1F1E1A",
};
const D = "'Fraunces', serif";
const S = "'IBM Plex Sans', system-ui, sans-serif";
const M = "'IBM Plex Mono', monospace";

export default function MockupKrans() {
  return (
    <div style={{ background: P.bg, color: P.ink, fontFamily: S, minHeight: "100vh" }}>
      <div style={{ position: "sticky", top: 0, zIndex: 20, background: "rgba(8,8,10,0.92)", backdropFilter: "blur(14px)", borderBottom: `1px solid ${P.border}` }}>
        <div style={{ maxWidth: 1180, margin: "0 auto", padding: "14px 28px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Link to="/mockups" style={{ fontFamily: M, fontSize: 10, color: P.inkDim, textDecoration: "none", letterSpacing: "0.2em" }}>← ALLE RETNINGER</Link>
          <span style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <KransMark />
            <span style={{ fontFamily: D, fontSize: 24, fontWeight: 500, color: P.brass, letterSpacing: "0.04em" }}>KRANS</span>
          </span>
          <span style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.brass }}>VAR 04C — METALL</span>
        </div>
      </div>

      <section style={{ maxWidth: 1180, margin: "0 auto", padding: "0 28px 100px" }}>
        <div style={{ paddingTop: 64 }}>
          <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.brass, marginBottom: 18 }}>01 · LANDING</div>
          <div style={{ background: P.panel, border: `1px solid ${P.border}` }}>
            <nav style={{ padding: "24px 56px", borderBottom: `1px solid ${P.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ display: "flex", alignItems: "center", gap: 12 }}><KransMark /><span style={{ fontFamily: D, fontSize: 26, color: P.brass, letterSpacing: "0.06em" }}>KRANS</span></span>
              <div style={{ display: "flex", gap: 36, fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.inkDim }}>
                <span>METODE</span><span>NIVÅ</span><span>INVITASJON</span>
              </div>
              <span style={{ fontFamily: M, fontSize: 10, color: P.brass, letterSpacing: "0.3em", borderBottom: `1px solid ${P.brass}`, paddingBottom: 2 }}>LOGG INN</span>
            </nav>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
              <div style={{ padding: "100px 56px 100px" }}>
                <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.35em", color: P.brass, marginBottom: 40 }}>EST. 2026 · OSLO · MEDLEMSKAP VED INVITASJON</div>
                <h1 style={{ fontFamily: D, fontSize: "clamp(56px, 7vw, 104px)", fontWeight: 400, letterSpacing: "-0.03em", lineHeight: 0.92, margin: 0, color: P.ink }}>
                  Et stille<br />verktøy for de<br /><em style={{ fontStyle: "italic", color: P.brass }}>som samler</em><br />for alvor.
                </h1>
                <p style={{ marginTop: 40, fontSize: 15, lineHeight: 1.75, color: P.inkDim, maxWidth: 420, fontFamily: S, letterSpacing: "0.01em" }}>
                  Krans er et premium medlemskap for nordmenn med ambisjoner — for deg som ikke betaler en regning uten å vite hvor mange EuroBonus-poeng den er verdt, og hvilket kort som maksimerer den.
                </p>
                <div style={{ marginTop: 48, display: "flex", gap: 16, alignItems: "center" }}>
                  <button style={{ background: P.brass, color: P.bg, border: "none", padding: "16px 30px", fontFamily: M, fontWeight: 600, fontSize: 12, letterSpacing: "0.3em", cursor: "pointer" }}>BE OM TILGANG</button>
                  <span style={{ fontFamily: M, fontSize: 11, color: P.inkDim, letterSpacing: "0.2em" }}>15 KR / MND · INGEN BINDING</span>
                </div>
              </div>

              {/* Black metal card */}
              <div style={{ padding: "100px 56px", background: P.bg, position: "relative", borderLeft: `1px solid ${P.border}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div style={{ width: "100%", maxWidth: 420, aspectRatio: "1.586/1", background: "linear-gradient(135deg, #18181B 0%, #050507 100%)", padding: 28, position: "relative", overflow: "hidden", boxShadow: `0 30px 80px rgba(0,0,0,0.7), inset 0 1px 0 rgba(212,179,128,0.2)`, border: `1px solid ${P.border}` }}>
                  <div style={{ position: "absolute", top: -40, right: -40, width: 220, height: 220, borderRadius: "50%", background: `radial-gradient(circle, ${P.brass}22 0%, transparent 70%)` }} />
                  <div style={{ position: "relative", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                    <KransMark size={36} />
                    <span style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.brass }}>DIAMOND</span>
                  </div>
                  <div style={{ position: "relative", fontFamily: D, fontSize: 48, color: P.brass, letterSpacing: "0.08em", marginTop: 32 }}>KRANS</div>
                  <div style={{ position: "relative", marginTop: 36, fontFamily: M, fontSize: 13, letterSpacing: "0.3em", color: P.ink }}>•••• •••• •••• 4302</div>
                  <div style={{ position: "relative", display: "flex", justifyContent: "space-between", marginTop: 20, fontFamily: M, fontSize: 9, letterSpacing: "0.25em", color: P.inkDim }}>
                    <span>SIMEN SKOG</span>
                    <span>EXP 06/29</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Editorial 3-col */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", borderTop: `1px solid ${P.border}` }}>
              {[
                { n: "I", t: "Diskresjon", b: "Ingen popups, ingen reklame, ingen forstyrrelser. Krans virker i bakgrunnen og dukker opp kun for handler som monner." },
                { n: "II", t: "Presisjon", b: "Vi sammenligner EuroBonus, Trumf og kort-bonuser i sanntid og forteller deg presist hvilket kort gir mest på den aktuelle handelen." },
                { n: "III", t: "Eksklusivitet", b: "Månedsrapport som leveres som en bok — printet i Oslo, sendt i sanntid. Eller digitalt, hvis du foretrekker det." },
              ].map((f) => (
                <div key={f.n} style={{ padding: "56px 36px", borderRight: `1px solid ${P.border}` }}>
                  <div style={{ fontFamily: D, fontSize: 64, fontWeight: 400, fontStyle: "italic", color: P.brass, letterSpacing: "-0.02em", lineHeight: 1 }}>{f.n}.</div>
                  <div style={{ fontFamily: D, fontSize: 28, fontWeight: 500, marginTop: 28, letterSpacing: "-0.01em" }}>{f.t}</div>
                  <div style={{ marginTop: 14, fontSize: 13, lineHeight: 1.7, color: P.inkDim }}>{f.b}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={{ paddingTop: 64 }}>
          <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.brass, marginBottom: 18 }}>02 · EXTENSION POPUP</div>
          <div style={{ background: P.bg, padding: "60px 0", display: "flex", justifyContent: "center", border: `1px solid ${P.border}`, position: "relative" }}>
            <div style={{ position: "absolute", inset: 0, background: `radial-gradient(circle at 50% 50%, ${P.brass}11 0%, transparent 60%)` }} />
            <div style={{ width: 360, background: P.panel, border: `1px solid ${P.brass}55`, position: "relative", boxShadow: `0 30px 80px rgba(0,0,0,0.6)` }}>
              <div style={{ padding: "16px 20px", borderBottom: `1px solid ${P.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ display: "flex", alignItems: "center", gap: 10 }}><KransMark size={18} /><span style={{ fontFamily: D, fontSize: 18, color: P.brass, letterSpacing: "0.06em" }}>KRANS</span></span>
                <span style={{ fontFamily: M, fontSize: 9, letterSpacing: "0.25em", color: P.inkDim }}>↻ OPPDATER</span>
              </div>
              <div style={{ padding: "20px 20px 0" }}>
                <div style={{ fontFamily: M, fontSize: 9, letterSpacing: "0.3em", color: P.inkDim, marginBottom: 4 }}>NÅVÆRENDE NETTSTED</div>
                <div style={{ fontFamily: D, fontSize: 26, fontWeight: 500, letterSpacing: "-0.01em" }}>komplett.no</div>
                <div style={{ marginTop: 8, display: "inline-flex", alignItems: "center", gap: 6, fontFamily: M, fontSize: 9, letterSpacing: "0.2em", color: P.brass }}><span style={{ width: 5, height: 5, borderRadius: "50%", background: P.brass }} />VERIFISERT · 4 METODER</div>
              </div>
              <div style={{ margin: "18px 20px", padding: 22, background: P.bg, border: `1px solid ${P.brass}33` }}>
                <div style={{ fontFamily: M, fontSize: 9, letterSpacing: "0.3em", color: P.brass, marginBottom: 8 }}>EUROBONUS · GULL ×2</div>
                <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
                  <span style={{ fontFamily: D, fontSize: 56, fontWeight: 500, color: P.brass, letterSpacing: "-0.04em", lineHeight: 1 }}>30</span>
                  <span style={{ fontFamily: D, fontSize: 22, color: P.ink, fontStyle: "italic" }}>poeng</span>
                </div>
                <div style={{ marginTop: 6, fontFamily: M, fontSize: 10, letterSpacing: "0.15em", color: P.inkDim }}>PER 100 KR · ≈ 6 % AVKASTNING</div>
                <div style={{ marginTop: 14, paddingTop: 14, borderTop: `1px solid ${P.border}`, fontSize: 12, color: P.inkDim, fontFamily: S }}>
                  Anbefalt kort: <span style={{ color: P.ink, fontWeight: 600 }}>SAS EuroBonus Diners</span>
                </div>
              </div>
              <div style={{ padding: "0 20px 12px" }}>
                <div style={{ fontFamily: M, fontSize: 9, letterSpacing: "0.3em", color: P.inkDim, marginBottom: 10 }}>METODER · 04</div>
                {["Visa","Mastercard","Vipps","Klarna"].map((m) => (
                  <div key={m} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${P.border}`, fontSize: 13 }}>
                    <span style={{ fontFamily: D, fontWeight: 500 }}>{m}</span>
                    <span style={{ fontFamily: M, fontSize: 10, color: P.brass, letterSpacing: "0.15em" }}>99 %</span>
                  </div>
                ))}
              </div>
              <div style={{ padding: "12px 20px 16px", borderTop: `1px solid ${P.border}`, display: "flex", justifyContent: "space-between", fontFamily: M, fontSize: 10, letterSpacing: "0.2em", color: P.inkDim }}>
                <span>4 / 7 VERIFISERT</span>
                <span><span style={{ color: P.brass }}>NO</span> / EN</span>
              </div>
            </div>
          </div>
        </div>

        <div style={{ paddingTop: 64 }}>
          <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.brass, marginBottom: 18 }}>03 · DASHBOARD</div>
          <div style={{ background: P.panel, border: `1px solid ${P.border}` }}>
            <nav style={{ padding: "22px 36px", borderBottom: `1px solid ${P.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", gap: 36, alignItems: "center" }}>
                <span style={{ display: "flex", alignItems: "center", gap: 10 }}><KransMark /><span style={{ fontFamily: D, fontSize: 22, color: P.brass, letterSpacing: "0.06em" }}>KRANS</span></span>
                <div style={{ display: "flex", gap: 24, fontFamily: M, fontSize: 10, letterSpacing: "0.3em" }}>
                  <span style={{ color: P.brass, borderBottom: `1px solid ${P.brass}`, paddingBottom: 4 }}>OVERSIKT</span>
                  <span style={{ color: P.inkDim }}>NIVÅ</span>
                  <span style={{ color: P.inkDim }}>INVITASJON</span>
                </div>
              </div>
              <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
                <span style={{ padding: "5px 12px", border: `1px solid ${P.brass}`, color: P.brass, fontFamily: M, fontSize: 9, letterSpacing: "0.25em" }}>DIAMOND</span>
                <span style={{ width: 32, height: 32, border: `1px solid ${P.brass}`, color: P.brass, display: "grid", placeItems: "center", fontFamily: D, fontWeight: 500 }}>S</span>
              </div>
            </nav>

            <div style={{ padding: "56px 36px", borderBottom: `1px solid ${P.border}` }}>
              <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.35em", color: P.inkDim, marginBottom: 24 }}>OPPTJENT · JUNI MMXXVI</div>
              <div style={{ fontFamily: D, fontSize: 140, fontWeight: 400, lineHeight: 0.9, letterSpacing: "-0.05em", color: P.brass }}>12 480</div>
              <div style={{ display: "flex", gap: 40, marginTop: 24, fontFamily: M, fontSize: 11, letterSpacing: "0.2em", color: P.inkDim }}>
                <span style={{ color: P.brassLite }}>POENG</span>
                <span>+22 % VS MAI</span>
                <span>≈ 1 248 KR</span>
                <span>TOP 3 % I NORGE</span>
              </div>
            </div>

            <div style={{ padding: "32px 36px" }}>
              <div style={{ fontFamily: D, fontSize: 28, fontWeight: 500, letterSpacing: "-0.01em", marginBottom: 18 }}>Siste handler</div>
              <div style={{ border: `1px solid ${P.border}` }}>
                <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1.6fr 1fr 80px", padding: "12px 22px", background: P.bg, fontFamily: M, fontSize: 9, letterSpacing: "0.3em", color: P.inkDim, borderBottom: `1px solid ${P.border}` }}>
                  <span>FORHANDLER</span><span>OPPTJENING</span><span>KORT</span><span style={{ textAlign: "right" }}>DATO</span>
                </div>
                {[
                  ["Komplett","komplett.no","+450 EuroBonus","Diners Premium","14.06"],
                  ["Hotels.com","hotels.com","+1 640 EuroBonus","Amex Platinum","12.06"],
                  ["XXL Sport","xxl.no","+240 EuroBonus","Diners Premium","09.06"],
                  ["Apollo Reiser","apollo.no","+3 800 EuroBonus","Amex Platinum","02.06"],
                ].map(([n,h,b,k,d]) => (
                  <div key={h} style={{ display: "grid", gridTemplateColumns: "1.4fr 1.6fr 1fr 80px", padding: "16px 22px", borderTop: `1px solid ${P.border}`, alignItems: "center", fontSize: 13 }}>
                    <div><div style={{ fontFamily: D, fontSize: 18 }}>{n}</div><div style={{ fontFamily: M, fontSize: 10, color: P.inkDim, letterSpacing: "0.1em" }}>{h}</div></div>
                    <div style={{ fontFamily: M, fontSize: 11, color: P.brass, letterSpacing: "0.1em" }}>{b}</div>
                    <div style={{ fontFamily: M, fontSize: 11, color: P.inkDim, letterSpacing: "0.08em" }}>{k}</div>
                    <div style={{ fontFamily: M, fontSize: 11, color: P.inkDim, textAlign: "right", letterSpacing: "0.1em" }}>{d}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function KransMark({ size = 22 }) {
  // Laurel wreath glyph
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" stroke="#B89968" strokeWidth="1.4">
      <path d="M16 4 L18 9 L23 9 L19 12 L21 17 L16 14 L11 17 L13 12 L9 9 L14 9 Z" fill="#B89968" />
      <path d="M6 16 Q 3 18 5 22 Q 9 21 11 24" />
      <path d="M26 16 Q 29 18 27 22 Q 23 21 21 24" />
      <path d="M11 24 Q 16 26 21 24" />
    </svg>
  );
}
